import { cn } from '@/lib/utils';

export type FilterChipSurface = 'segment' | 'pill';
export type FilterChipTone = 'primary' | 'success' | 'danger';

const CHIP_FOCUS =
    'focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40';

const PILL_ACTIVE: Record<FilterChipTone, string> = {
    primary: 'border-primary/40 bg-primary-subtle font-medium text-primary',
    success: 'border-success/40 bg-success-bg font-medium text-success-text',
    danger: 'border-error/40 bg-danger-bg font-medium text-danger-text',
};

const PILL_INACTIVE: Record<FilterChipTone, string> = {
    primary: 'border-border bg-surface font-normal text-secondary hover:border-primary/40 hover:text-primary',
    success: 'border-border bg-surface font-normal text-secondary hover:border-success/40 hover:text-success-text',
    danger: 'border-border bg-surface font-normal text-secondary hover:border-error/40 hover:text-danger-text',
};

const SEGMENT_ACTIVE: Record<FilterChipTone, string> = {
    primary: 'bg-primary-subtle font-medium text-primary md:border-primary/40',
    success: 'bg-success-bg font-medium text-success-text md:border-success/40',
    danger: 'bg-danger-bg font-medium text-danger-text md:border-error/40',
};

const SEGMENT_INACTIVE: Record<FilterChipTone, string> = {
    primary: 'text-secondary hover:text-primary md:border-border md:bg-surface md:hover:border-primary/40',
    success: 'text-secondary hover:text-success-text md:border-border md:bg-surface md:hover:border-success/40',
    danger: 'text-secondary hover:text-danger-text md:border-border md:bg-surface md:hover:border-error/40',
};

/** Trigger compartilhado: segmento (barra agrupada) ou pill (filtro solto). */
export function cnFilterChip(
    active: boolean,
    surface: FilterChipSurface = 'segment',
    tone: FilterChipTone = 'primary',
): string {
    if (surface === 'pill') {
        return cn(
            'inline-flex h-11 w-auto shrink-0 touch-manipulation items-center justify-center gap-s2 rounded-full border px-s3 text-sm transition-colors',
            'md:h-8',
            'motion-reduce:transition-none',
            CHIP_FOCUS,
            active ? PILL_ACTIVE[tone] : PILL_INACTIVE[tone],
        );
    }

    return cn(
        'group inline-flex min-h-11 w-full min-w-0 max-w-full items-center justify-center gap-s1 overflow-hidden px-s2',
        'text-sm font-normal touch-manipulation transition-colors',
        'rounded-none border-0 bg-transparent',
        CHIP_FOCUS,
        'md:h-9 md:min-h-0 md:w-auto md:max-w-none md:justify-start md:gap-s2 md:overflow-visible md:rounded-full md:border md:px-s3',
        active ? SEGMENT_ACTIVE[tone] : SEGMENT_INACTIVE[tone],
    );
}
